import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto grid max-w-7xl gap-20 xl:grid-cols-3" }
const _hoisted_2 = { class: "max-w-xl" }
const _hoisted_3 = {
  role: "list",
  class: "grid gap-x-8 gap-y-12 sm:grid-cols-2 sm:gap-y-16 xl:col-span-2"
}

import { computed } from "vue";
import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import { PageBlock } from "@/views/blocks/PageBlock.interface";
import EditableElement from "@/views/page/EditableElement.vue";

// Import shared components
import Section from "@/views/blocks/shared/section/layout/section/Section.vue";
import FullSpacing from "@/views/blocks/shared/section/layout/spacing/FullSpacing.vue";
import Heading from "@/views/blocks/shared/section/typography/heading/Heading.vue";
import Paragraph from "@/views/blocks/shared/section/typography/paragraph/Paragraph.vue";
import type { WithSmallImagesProps } from "./WithSmallImagesProps";
import Member from "./components/members/Member.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'WithSmallImages',
  props: {
    block: {},
    pageColors: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Section, {
    id: _ctx.block.webId,
    backgroundColor: styleValues.value.background
  }, {
    default: _withCtx(() => [
      _createVNode(FullSpacing, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (!dataValues.value.title.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 0,
                    blockId: _ctx.block.id,
                    "field-name": "title"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Heading, _mergeProps(dataValues.value.title.data, {
                        textColor: styleValues.value.text,
                        class: "text-3xl sm:text-4xl"
                      }), null, 16, ["textColor"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true),
              (!dataValues.value.description.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 1,
                    blockId: _ctx.block.id,
                    "field-name": "description"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Paragraph, _mergeProps(dataValues.value.description.data, {
                        class: "mt-6 text-lg/8 opacity-70",
                        textColor: styleValues.value.text
                      }), null, 16, ["textColor"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataValues.value.members.data.items, (member) => {
                return (_openBlock(), _createBlock(EditableElement, {
                  key: member.id,
                  blockId: _ctx.block.id,
                  "field-name": `members_${member.id}`,
                  hideable: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(Member, _mergeProps({ ref_for: true }, member, {
                      nameTextColor: styleValues.value.text,
                      roleTextColor: styleValues.value.brand
                    }), null, 16, ["nameTextColor", "roleTextColor"])
                  ]),
                  _: 2
                }, 1032, ["blockId", "field-name"]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "backgroundColor"]))
}
}

})